import Checkbox from '@ui/Table/Checkbox';
import moment from 'moment';
import { useController, useFormContext } from 'react-hook-form';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    name: string;
    label?: string;
}

export default function FormWeekdays({ name, label, ...props }: Props) {
    const { control } = useFormContext();
    const {
        field: { value, onChange }
    } = useController({ name, control });
    const weekdays = moment.weekdays();
    weekdays.push(weekdays.shift());

    const handleChange = (index: number) => {
        let newValue = value ?? [];
        if (newValue.includes(index)) {
            newValue = newValue.filter((day) => day !== index);
        } else {
            newValue.push(index);
        }

        onChange(newValue);
    };

    return (
        <div {...props}>
            <label className="tw-pl-1">{label}</label>
            <div className="tw-flex tw-justify-around tw-gap-2">
                {weekdays.map((day, index) => (
                    <div key={day} className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">
                        <Checkbox
                            isSelected={(value ?? []).includes(index)}
                            defaultSelected={(value ?? []).includes(index)}
                            name={`${name}.${index}`}
                            onChange={() => handleChange(index)}
                        />
                        <span>{day.substring(0, 2)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
